import React, { useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  IconButton, MenuItem, Select, SelectChangeEvent, TextField,
} from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Box } from '@mui/system';
import { IFileMutationVariables } from '../core/api/hooks/common/useUploadUserGuide';
import { AuthorizedForm, ReportType } from '../core/api/clients';
import { SplitPascalCase } from './Utility/Cases';

interface IUserGuideDialog {
  isOpen: boolean,
  onClose: () => void,
  onAccept: (file: IFileMutationVariables | undefined) => void;
  authorizedForms: AuthorizedForm[];
}

function UserGuideDialog({ isOpen, onClose, onAccept, authorizedForms }: IUserGuideDialog) {
  const [guideTypes, setGuideTypes] = React.useState<string[]>();
  const [selectedGuideType, setSelectedGuideType] = React.useState<string>();
  const [file, setFile] = React.useState<IFileMutationVariables>();
  const inputFile = useRef<HTMLInputElement>(null);
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileTarget = e.target.files ? e.target.files[0] : null;
    if (fileTarget !== null && selectedGuideType) {
      const filename = fileTarget.name;

      const parts = filename.split('.');
      const fileType = parts[parts.length - 1];
      const reportType = ReportType[selectedGuideType as keyof typeof ReportType];
      if (fileType.includes('pdf')) {
        setFile(
          {
            reportType,
            size: fileTarget.size,
            fileName: fileTarget.name,
            formFile: {
              data: fileTarget,
              fileName: fileTarget.name,
            },
          },
        );
      }
    }
  };
  useEffect(() => {
    let formNames: string[] = [];
    if (authorizedForms) {
      for (let i = 0; i < authorizedForms.length; i += 1) {
        const form = authorizedForms[i];
        if (form && form.metadata && form.metadata.reportType) {
          formNames = [...formNames, form.metadata.reportType?.toString()];
          if (form.metadata.reportType === ReportType.Incident) {
            formNames = [...formNames, 'Forms Site'];
          }
        }
      }
    }
    setGuideTypes(formNames);
  }, [authorizedForms]);
  return (
    <Dialog
      fullWidth
      open={isOpen}
      onClose={onClose}
    >
      <input
        style={{ display: 'none' }}
        ref={inputFile}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFileUpload(e)}
        type="file"
      />
      <DialogTitle>
        User Guide Change
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="row" alignItems="center">
          <DialogContentText>
            Which User Guide
          </DialogContentText>
          <Select
            sx={{ ml: 3, minWidth: 200, height: 30 }}
            variant="standard"
            label="Group By"
            value={selectedGuideType}
            onChange={(event: SelectChangeEvent<string>) => {
              setSelectedGuideType(event.target.value);
            }}
          >
            {guideTypes && guideTypes.map((guideType) => (
              <MenuItem key={guideType} value={guideType}>
                {guideType}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="center" mt={1}>
          <TextField
            disabled
            required
            fullWidth
            helperText="file name"
            label={file ? file.fileName : ''}
            variant="standard"
          />
          <IconButton
            disabled={selectedGuideType === undefined}
            autoFocus
            onClick={(() => {
              inputFile.current?.click();
            })}
          >
            <FileUploadIcon />
          </IconButton>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error" autoFocus>Cancel</Button>
        <Button onClick={() => onAccept(file)}>
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default UserGuideDialog;
